import { useSearchParams } from 'react-router';

type EditorParam = {
  /** The record being edited, "new", or null when closed. */
  readonly editing: string | null;
  readonly params: URLSearchParams;
  readonly open: (id: string, extra?: Readonly<Record<string, string>>) => void;
  readonly close: () => void;
};

/** Editors open from the URL (?edit=<id> or ?edit=new) so the back button closes them. */
export function useEditorParam(): EditorParam {
  const [params, setParams] = useSearchParams();

  function open(id: string, extra: Readonly<Record<string, string>> = {}) {
    setParams(function withEditor(current) {
      const next = new URLSearchParams(current);
      next.set('edit', id);
      for (const [key, value] of Object.entries(extra)) next.set(key, value);
      return next;
    });
  }

  function close() {
    // Go back when we pushed the entry ourselves, so "back" after closing leaves the page.
    if (window.history.state?.idx > 0) {
      window.history.back();
      return;
    }
    setParams(function withoutEditor(current) {
      const next = new URLSearchParams(current);
      next.delete('edit');
      return next;
    });
  }

  return { editing: params.get('edit'), params, open, close };
}
